

import React, { useState } from "react";

function FormatAccount(props)
{

    var val = props.value;

     
    var f =  props.value;
    var country = 'PL';

    if(val.length > 26 )
    {
        country = val.replace(/[0-9]/, '');
        val = val.replace(/[^0-9]/, '');
    }
    if(val.length == 26)
    {
        var x = val.split('');
        f =  country + " " + x[0]+""+x[1] + " " +x[2]+""+x[3]+""+x[4]+""+x[5]+" " +x[6]+""+x[7]+""+x[8]+""+x[9] + " "+x[10]+""+x[11]+""+x[12]+""+x[13]+" "+x[14]+""+x[15]+""+x[16]+""+x[17] + " " +x[18]+""+x[19]+""+x[20]+""+x[21] +" "+x[22]+""+x[23]+x[24]+""+x[25];
    }


    return <React.Fragment>
        {f}
    </React.Fragment>
}

export default FormatAccount;